import _slicedToArray from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var colorShade = function colorShade(col, amt) {
  col = col.replace(/^#/, '');
  if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];

  var _ref = col.match(/.{2}/g) || ['ff', 'ff', 'ff'],
      _ref2 = _slicedToArray(_ref, 3),
      sr = _ref2[0],
      sg = _ref2[1],
      sb = _ref2[2];

  var ar = parseInt(sr, 16) + amt,
      ag = parseInt(sg, 16) + amt,
      ab = parseInt(sb, 16) + amt;
  var r = Math.max(Math.min(255, ar), 0).toString(16);
  var g = Math.max(Math.min(255, ag), 0).toString(16);
  var b = Math.max(Math.min(255, ab), 0).toString(16);
  var rr = (r.length < 2 ? '0' : '') + r;
  var gg = (g.length < 2 ? '0' : '') + g;
  var bb = (b.length < 2 ? '0' : '') + b;
  return "#".concat(rr).concat(gg).concat(bb);
};
var defaultColors = ['#E64980', '#4C6EF5', '#228BE6', '#15AABF', '#12B886', '#40C057', '#82C91E', '#FAB005', '#FD7E14', '#FA5252'];
export function getColorFromString(value) {
  var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultColors;
  var hash = 0;
  if (value.length === 0) return colors[hash];

  for (var i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  hash = (hash % colors.length + colors.length) % colors.length;
  return colors[hash];
}